module.exports = __webpack_public_path__ + "static/SectionTwoBackground.facae413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngs/SectionTwoBackground.png
// module id = 500
// module chunks = 35783957827783